import React from "react";

const MyStones = () => {
  return (
    <div>
      MyStones Under construction...
    </div>
  );
};

export default MyStones;